var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dispatch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M18.3607 8.10536C18.6258 8.50204 18.8519 8.9207 19.0372 9.35547H18.75V15.3555H21.75V9.35547H20.4853C20.2371 8.65337 19.9014 7.98111 19.4832 7.35534C18.4943 5.8753 17.0887 4.72175 15.4442 4.04056C13.7996 3.35937 11.99 3.18114 10.2442 3.52841C8.49836 3.87567 6.89472 4.73284 5.63604 5.99151C4.68312 6.94443 3.96033 8.09509 3.51472 9.35547H2.25V15.3555H3.51472C3.56749 15.5047 3.62429 15.6528 3.68509 15.7996C4.36628 17.4442 5.51983 18.8498 6.99987 19.8387C7.62564 20.2568 8.2979 20.5925 9 20.8408V21.3555H13.5V19.1055H9V19.3927C8.56523 19.2074 8.14657 18.9813 7.74989 18.7162C6.51365 17.8902 5.54539 16.7221 4.96278 15.3555H5.25V9.35547H4.96278C5.34449 8.46009 5.89553 7.64121 6.59064 6.94611C7.66051 5.87623 9.02361 5.14764 10.5076 4.85246C11.9915 4.55729 13.5297 4.70878 14.9275 5.28779C16.3254 5.8668 17.5202 6.84732 18.3607 8.10536Z",
    fill: "#C93030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/services-icon.196fdc1552d0f340a61c7eae2ab9777a.svg";
export { ForwardRef as ReactComponent };